import CheckIcon from "@material-ui/icons/Check";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { handleCopyCode } from "app/common/LocalFunction";
import React, { memo, useState } from "react";

const CopyableCodeCell = ({ value, size = "default" }) => {
  const [copied, setCopied] = useState(false);
  const isSmall = size === "small";
  const buttonSize = isSmall ? 28 : 36;
  const iconSize = isSmall ? 16 : 19;

  const handleCopy = (event) => {
    event?.stopPropagation?.();
    if (!value || copied) return;
    handleCopyCode(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  if (value == null || value === "") {
    return <span style={{ color: "#aaa" }}>-</span>;
  }

  const displayValue = String(value);

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: isSmall ? 6 : 10,
        maxWidth: "100%",
      }}
    >
      <span
        style={{
          fontWeight: 500,
          letterSpacing: "0.2px",
          whiteSpace: "nowrap",
        }}
      >
        {displayValue}
      </span>
      <div
        style={{
          width: buttonSize,
          height: buttonSize,
          minWidth: buttonSize,
          borderRadius: "50%",
          backgroundColor: copied ? "rgba(0, 0, 0, 0.08)" : "transparent",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          transition: "all 180ms ease",
          flexShrink: 0,
        }}
        onClick={handleCopy}
        title={copied ? "Đã sao chép!" : "Sao chép mã"}
        role="button"
        tabIndex={0}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            handleCopy(event);
          }
        }}
      >
        {copied ? (
          <CheckIcon style={{ fontSize: iconSize + 1, color: "#666" }} />
        ) : (
          <FileCopyIcon style={{ fontSize: iconSize, color: "#666" }} />
        )}
      </div>
    </div>
  );
};

export default memo(CopyableCodeCell);
